// =============================================================================
// MeuDriver — HomeRoute ("/")
// =============================================================================
// Visitante vê a landing. Quem está logado vai direto ao próprio painel — a
// landing (vitrine, "crie sua conta") não faz sentido para quem já tem conta.

import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { BrandLoadingScreen } from '@/components/shared/BrandLoadingScreen'
import { roleDashboard } from '@/routes/roleDashboard'
import LandingPage from '@/pages/public/LandingPage'

export function HomeRoute() {
  const { user, profile, profileLoading } = useAuth()

  if (!user) return <LandingPage />
  if (profile) return <Navigate to={roleDashboard[profile.role]} replace />
  // Logado, perfil ainda chegando: abertura em vez de piscar a landing.
  if (profileLoading) return <BrandLoadingScreen />
  return <LandingPage />
}

export default HomeRoute
